<template>
  <div class="mb-5">
    <v-tabs :value="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{tab.title}}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
import {toString} from "lodash";

export default {
  name: "ProfitTabs",
  data() {
    return {
    };
  },
  computed: {
    selectedTab(){
      if(this.$route.name == 'WareProfitReport') {
        return 0
      } else {
        return 1
      }
    },
    tabs() {
      return [
        {title: 'گزارش سود کالا', key: 'WareProfitReport'},
        {title: 'گزارش سود خدمات', key: 'ServicesProfitReport', type: false},
      ]
    },
  },
  methods: {
    changeRoute(tab){
      this.$router.push({
        name: tab.key
      })
    }
  }

};
</script>

<style scoped lang="scss">
</style>

